import React from 'react';
import xIcon from '../assets/x.svg';
import '../styles/attributes.css';

function X() {
  return <img className="letter" src={xIcon} alt="o-letter" />;
}

export default X;
